import {
  extendTheme,
  ThemeOverride,
  withDefaultColorScheme,
} from "@chakra-ui/react";
import { CalendarDefaultTheme } from "@uselessdev/datepicker";
import colors from "theme/colors";
import Accordion from "theme/components/AccordionTheme";
import Alert from "theme/components/AlertTheme";
import Badge from "theme/components/BadgeTheme";
import Breadcrumb from "theme/components/BreadcrumbTheme";
import Button from "theme/components/ButtonTheme";
import CalendarControl from "theme/components/CalendarControlTheme";
import CalendarDay from "theme/components/CalendarDayTheme";
import CalendarMonth from "theme/components/CalendarMonthTheme";
import Calendar from "theme/components/CalendarTheme";
import Card from "theme/components/CardTheme";
import Checkbox from "theme/components/CheckboxTheme";
import ContentBlock from "theme/components/ContentBlockTheme";
import DescriptionList from "theme/components/DescriptionListTheme";
import Drawer from "theme/components/DrawerTheme";
import DropdownButton from "theme/components/DropdownButtonTheme";
import Fieldset from "theme/components/FieldsetTheme";
import FormError from "theme/components/FormErrorTheme";
import FormLabel from "theme/components/FormLabelTheme";
import Form from "theme/components/FormTheme";
import Input from "theme/components/InputTheme";
import Link from "theme/components/LinkTheme";
import Menu from "theme/components/MenuTheme";
import Modal from "theme/components/ModalTheme";
import PageHeader from "theme/components/PageHeaderTheme";
import Popover from "theme/components/PopoverTheme";
import Progress from "theme/components/ProgressTheme";
import Radio from "theme/components/RadioTheme";
import Select from "theme/components/SelectTheme";
import Spinner from "theme/components/SpinnerTheme";
import Stat from "theme/components/StatTheme";
import Table from "theme/components/TableTheme";
import Tabs from "theme/components/TabsTheme";
import Text from "theme/components/TextTheme";
import Toast from "theme/components/ToastTheme";
import ToggleButton from "theme/components/ToggleButtonTheme";
import Tooltip from "theme/components/TooltipTheme";
import { shadows } from "theme/shadows";
import { styles } from "theme/styles";
import { textStyles } from "theme/textStyles";
import zIndices from "theme/zIndices";

/*eslint sort-keys: "error"*/

export const theme: ThemeOverride = extendTheme(
  {
    colors,
    components: {
      Accordion,
      Alert,
      Badge,
      Breadcrumb,
      Calendar,
      CalendarControl,
      CalendarDay,
      CalendarMonth,
      Card,
      Checkbox,
      ContentBlock,
      DescriptionList,
      Drawer,
      DropdownButton,
      Fieldset,
      Form,
      FormError,
      FormLabel,
      Input,
      Link,
      Menu,
      Modal,
      PageHeader,
      Popover,
      Progress,
      Radio,
      Select,
      Spinner,
      Table,
      Tabs,
      Text,
      Toast,
      ToggleButton,
      Tooltip,
    },
    fonts: {
      body: "Inter, sans-serif",
      heading: "Inter, sans-serif",
    },
    semanticTokens: {
      colors: {
        "chakra-body-text": {
          _light: "gray.700",
        },
        highlight: {
          _light: "primary.25",
        },
      },
    },
    shadows,
    styles,
    textStyles,
    zIndices,
  },
  extendTheme(
    CalendarDefaultTheme,
    withDefaultColorScheme({ colorScheme: "primary" }),
  ),
);

// Overwrite defaults completely, do not merge with chakra theme.
theme.components!.Button = Button;
theme.components!.Stat = Stat;
